module.exports = __webpack_public_path__ + "media/images/mbd-benefits-cc7c029db12abb31026c24705e3aa62e.webp";